import { createFeature, createReducer, on } from '@ngrx/store';
import * as actions from './rfr-save.actions';
import { RfrSaveQueryI } from 'src/app/api/rfr-save/rfr-save.query.int';
import { RfrSaveI } from 'src/app/api/rfr-save/rfr-save.result.int';

export interface State {
  data: RfrSaveI;
  errorMessage: string;
  loaded: boolean;
  loading: boolean;
  query: RfrSaveQueryI;
}

export const initialState: State = {
  data: null,
  errorMessage: null,
  loaded: null,
  loading: null,
  query: null,
};

export default createFeature({
  name: 'rfrSave',
  reducer: createReducer(
  initialState,
  on(actions.error, (state: State, { messageText }): State => ({
    ...state,
    loading: false,
    errorMessage: messageText
  })),
  on(actions.load, (state: State, { query }): State => ({
    ...state,
    loading: true,
    query,
  })),
  on(actions.received, (state: State, { data }): State => ({
    ...state,
    loaded: true,
    loading: false,
    data,
  })),
  on(actions.reset, (_state: State, { }): State => ({
    ...initialState,
  })),
)}
);